export const shortFormatter = (
  value: number,
  unit: 'second' | 'minute' | 'hour' | 'day' | 'week' | 'month' | 'year',
  suffix: 'ago' | 'from now',
) => {
  const abbr: Record<typeof unit, string> = {
    second: 's',
    minute: 'm',
    hour: 'h',
    day: 'd',
    week: 'w',
    month: 'mo',
    year: 'y',
  }

  if (unit === 'second') {
    return suffix === 'ago' ? 'Just now' : 'Soon'
  }

  const n = Math.round(value)
  return suffix === 'ago' ? `${n}${abbr[unit]} ago` : `in ${n}${abbr[unit]}`
}
